import type { IDomainAddress } from "~/domain/address";

export class ValidationError extends Error {
  meta: Partial<Record<keyof IDomainAddress, string>>;

  constructor(
    message: string,
    meta: Partial<Record<keyof IDomainAddress, string>>,
  ) {
    super(message);
    this.name = "ValidationError";
    this.meta = meta;
  }
}
